import React from 'react';
import { useAppSelector } from '../../stores/hooks';
import { ShadeMode } from '../../stores/state';

/**
 * Expenditures icon component
 * Displays the custom expenditures SVG icon with automatic dark/light mode styling
 */
export const ExpendituresIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const mode = useAppSelector((state) => state.vault.mode);
  const arrowColor = mode === ShadeMode.Dark ? '#ffffff' : '#000000';

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m 1.988224,11.372881 6,6.000001 V 2.1016946 h -6 z"
        fill="#912e2e"
        fillOpacity="0.298824"
      />
      <path
        d="m 7.988224,17.372882 6,-4.000001 V 2.1016946 h -6 z"
        fill="#912e2e"
        fillOpacity="0.6"
      />
      <path
        d="m 13.988224,13.372881 6,6.000001 V 2.1016946 h -6 z"
        fill="#912e2e"
        fillOpacity="0.901176"
      />
      <path
        d="m 16,21.677967 h 6 v -6"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 22,21.677967 13.5,13.177966 8.5,18.177967 2,11.677966"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
